import { Env } from "lib-klab-core";

import { envDocumentDev } from "./klab/document";
import { envKlabIamDev } from "./klab/iam";
import { envKlabMessagingDev } from "./klab/messaging";
import { envKlabNotificationsDev } from "./klab/notifications";
import { envOrganizationDev } from "./klab/organization";
import { envPeopleDev } from "./klab/people";
import { envReportDev } from "./klab/report";

import { envAgreementDev } from "./staff/agreement";
import { envEmployeeDev } from "./staff/employee";
import { envHrDev } from "./staff/hr";
import { envPayrollDev } from "./staff/payroll";
import { envStaffOrganizationDev } from "./staff/organization";

export const environment: Env = {
    production: false,
    micros: {
        iam: envKlabIamDev,
        organization: envOrganizationDev,
        report: envReportDev,
        people: envPeopleDev,
        messaging: envKlabMessagingDev,
        document: envDocumentDev,
        notifications: envKlabNotificationsDev,
        staffOrganization: envStaffOrganizationDev,
        employee: envEmployeeDev,
        hr: envHrDev,
        payroll: envPayrollDev,
        agreement: envAgreementDev,
    },
};
